import deepMerge from 'lodash.merge';
import unset from 'lodash.unset';
import {isObject} from 'utils/objects';

/**
 * little-state-machine reducer for form state
 * Supports one of each form type
 */

const arrayContentsAreComplex = array =>
    array.filter(item => typeof item === 'object').length > 0;

const getFormSectionDataReducer = (root, merge = true) => {
    const formName = root || 'newForm';

    if (merge) {
        return (state, payload) => {
            // Cheap deep clone
            let stateCopy = JSON.parse(JSON.stringify(state));
            // Unset incoming data points from existing state
            // Thar be dragons here.
            // Incoming payload is assumed to be a single level object OR array
            //  where values will be overwritten. This allows us to support
            //  rich json values or array values and not get too crazy with
            //  state updates
            // Only typeof value === 'object' ||
            //   (typeof value === 'array' && value[0] !== 'object') will be unset
            //  (json fields and arrays of primitives)
            Object.keys(payload)
                .filter(
                    key =>
                        isObject(payload[key]) ||
                        (Array.isArray(payload[key]) &&
                            !arrayContentsAreComplex(payload[key]))
                )
                .forEach(key => {
                    unset(stateCopy, `forms.${formName}.${key}`);
                });
            // Merge payload into interim state
            const data = deepMerge(stateCopy, {
                forms: {
                    [formName]: {
                        ...payload,
                    },
                },
            });

            return data;
        };
    } else {
        return (state, payload) => {
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [formName]: {
                        ...state.forms[formName],
                        ...payload,
                    },
                },
            };
        };
    }
};

export default getFormSectionDataReducer;
